import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'echarts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
import api from'./api/feeding'
import './directives';
import '@/icons' // icon
import '@/permission' // permission control
Vue.prototype.VCharts = VCharts
Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

Vue.prototype.$ajax = api;
Vue.prototype.FeedType = {
  'BYS': '保育',
  'FMS': '分娩',
  'YFS': '育肥',
  'PHS': '配怀'
}
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js